import { WebHttpRequestOptions } from '@am92/web-http'

import { createInquiryServiceName, createInquiryTraceActions } from '../Actions'

import serviceActionCreatorWithTokenRotation from '~/src/Redux/serviceActionCreatorWithTokenRotation'

import { asHttp } from '~/src/Configurations/WebHttp'

export interface ICreateInquiryRequestData {
  fullName: string
  emailId: string
  subject: string
  message: string
}

async function createInquiry(reqData: ICreateInquiryRequestData) {
  const options: WebHttpRequestOptions = {
    url: '/inquiries',
    method: 'POST',
    data: reqData
  }

  const response = await asHttp.request(options)
  const { data: body } = response
  const { data } = body
  return data
}

const createInquiryService = serviceActionCreatorWithTokenRotation(
  createInquiryTraceActions,
  createInquiry
)

export default createInquiryService
export { createInquiryServiceName }
